var render = function render(){var _vm=this,_c=_vm._self._c;return _c('plans',{attrs:{"loading":_vm.loading},on:{"update:loading":function($event){_vm.loading=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }